import { ref } from '@vue/composition-api';
import { useAppListApi } from '@tt4b/ttam-hooks';
import { AppItem } from '@tt4b/ttam-enums';

const loading = ref(false);
const oriAppList = ref<AppItem[]>([]);
let isFetched = false;

export function useAppList() {
  function setAppList(arr: AppItem[]) {
    oriAppList.value = arr;
  }

  function loadAppList(parmas = {}, shouldUseCache = false) {
    if (shouldUseCache && isFetched) {
      return;
    }
    loading.value = true;
    return useAppListApi(parmas)
      .then(arr => {
        setAppList(arr ?? []);
        isFetched = true;
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    loading,
    oriAppList,
    loadAppList,
  };
}
